<template>
    <div class="block">
        <a href="#" :class=" isLoadMediaInfo && isLoadPhotos ? 'title open': 'title'" @click.prevent="loadData">Сведения о школьной медиастудии (пресс-центре)</a>
        <div class="content" v-if="isLoadMediaInfo && isLoadPhotos">
            <div>
                <table>
                    <thead>
                    <tr>
                        <th>Тип медиастудии</th>
                        <th>Оборудование медиастудии</th>
                        <th>Адрес</th>
                    </tr>
                    </thead>
                    <tbody v-if="mediaInfo">
                        <tr v-bind:key="item.id" v-for="item in this.mediaInfo">
                            <td>{{ typeof(item.mediaType) !== 'undefined' ? item.mediaType.name : "" }}</td>
                            <td>{{ item.equipment }}</td>
                            <td>{{ item.address }}</td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td colspan="3">Загрузка данных...</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div>
                <span v-if="photos">
                    <h3>Фотографии лабораторий</h3>
                        <!--<a v-bind:key="item.id" v-for="item in getPhotosByProject()" :href="item.path" target="_blank" style="margin: 2px 5px; display:inline-block;">-->
                            <!--<img :src="item.path" style="max-width: 250px;" />-->
                        <!--</a>-->
                        <viewer :images="getPhotosByProject()">
                            <img v-for="src in getPhotosByProject()" :src="src.path" :key="src.path" style="max-width: 250px;margin: 2px 5px; display:inline-block;">
                        </viewer>
                    </span>
                <span v-else>
                    Загрузка данных...
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import Axios from 'axios'
    import _ from 'lodash'
    import 'viewerjs/dist/viewer.css'
    export default {
        name: "MediaEquipment",
        data() {
            return {
                isLoadMediaInfo:false,
                mediaInfo: false,
                isLoadPhotos: false,
                photos: false
            }
        },


        created(){
        },


        methods:{

            loadData(){
                this.getMediaInfo()
                this.getPhotos()
            },


            getMediaInfo(){
                if(!this.isLoadMediaInfo && !this.mediaInfo){
                    this.isLoadMediaInfo = true
                    const path = this.$store.state.api + this.$store.state.apiMediaEquipment + "?eoId=" + this.$store.state.eoId
                    const $this = this

                    Axios({
                        method: "get",
                        url: path,
                    }).then((res)=>{
                        if(
                            res.status == 200
                            && res.data.result == "success"
                        ){
                            $this.mediaInfo = res.data.data
                        }
                    })
                }else{
                    this.isLoadMediaInfo = !this.isLoadMediaInfo
                }
            },


            getPhotos(){
                if(!this.isLoadPhotos && !this.photos){
                    this.isLoadPhotos = true
                    const path = this.$store.state.api + this.$store.state.apiPhotosEquipment + "?eoId=" + this.$store.state.eoId
                    const $this = this

                    Axios({
                        method: "get",
                        url: path
                    }).then((res)=>{
                        if(
                            res.status == 200
                            && res.data.result == "success"
                        ){
                            $this.photos = res.data.data;
                        }
                    })
                }else{
                    this.isLoadPhotos = !this.isLoadPhotos
                }

            },
            getPhotosByProject(){
                var $this = this

                return _.filter(this.photos, function(o){
                    return o.projectType.altName == $this.$store.state.type
                });
            },
        }
    }
</script>

<style scoped>

</style>
